import script from "./table-cell-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./table-cell-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./table-cell-setting-ly.vue?vue&type=style&index=0&id=381f8518&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-381f8518"]])

export default __exports__